/**
 * Licensed Materials - Property of IBM
 * 5737-M66, 5900-AAA, 5900-A0N, 5725-S86, 5737-I75
 * © Copyright IBM Corp. 2020, 2023 All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication, or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import get from 'lodash/get';
import keyBy from 'lodash/keyBy';
import { createSelector } from 'reselect';

import { formatEntityTypes } from 'exploreDataFormatterFunctions';
import {
  GET_ENTITYTYPES_DATA,
  GET_ENTITYTYPES_DATA_FAILURE,
  GET_ENTITYTYPES_DATA_SUCCESS,
  GET_ENTITYTYPE_DETAIL,
  GET_ENTITYTYPE_DETAIL_FAILURE,
  GET_ENTITYTYPE_DETAIL_SUCCESS,
} from 'entityTypeActionCreators';
// reducer
export const entityTypesReducer = (state = { data: {}, fetchingData: false }, action) => {
  switch (action.type) {
    case GET_ENTITYTYPES_DATA:
      return {
        ...state,
        fetchingData: true,
        fetchDataError: null,
      };
    case GET_ENTITYTYPES_DATA_FAILURE:
      return {
        ...state,
        fetchingData: false,
        fetchDataError: action.payload,
      };
    case GET_ENTITYTYPES_DATA_SUCCESS:
      return {
        ...state,
        fetchingData: false,
        fetchDataError: null,
        data: keyBy(formatEntityTypes(action.payload), 'name'),
        serverData: keyBy(action.payload, 'name'),
      };
    default:
      return state;
  }
};

// Details reducer for just one entity type
export const entityTypeDetailsReducer = (state = { data: {}, fetchingData: false }, action) => {
  switch (action.type) {
    case GET_ENTITYTYPE_DETAIL:
      return {
        ...state,
        fetchingData: true,
        fetchDataError: null,
      };
    case GET_ENTITYTYPE_DETAIL_FAILURE:
      return {
        ...state,
        fetchingData: false,
        fetchDataError: action.payload,
      };
    case GET_ENTITYTYPE_DETAIL_SUCCESS:
      return {
        ...state,
        fetchingData: false,
        fetchDataError: null,
        data: action.payload,
      };

    default:
      return state;
  }
};

const selectEntityTypes = state => get(state, 'entityTypes.data', {});
// Selectors
export const getEntityTypes = createSelector([selectEntityTypes], entityTypes =>
  Object.values(entityTypes)
);

export const getEntityTypesFetchingData = state => get(state, 'entityTypes.fetchingData');

export const getEntityTypesDataError = state => get(state, 'entityTypes.fetchDataError');

export const getEntityTypeDetails = state => get(state, 'entityTypeDetails.data') || {};
